/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ReflectionInputs */

const en_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflection`)
};

const ar_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التأمل`)
};

const bn_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিফ্লেকশন`)
};

const de_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflexion`)
};

const es_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflexión`)
};

const fr_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réflexion`)
};

const pt_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reflexão`)
};

const zh_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反思`)
};

const tr_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yansıma`)
};

const ru_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отражение`)
};

const pl_svchip_reflection = /** @type {(inputs: Svchip_ReflectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refleksja`)
};

/**
* | output |
* | --- |
* | "Reflection" |
*
* @param {Svchip_ReflectionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_reflection = /** @type {((inputs?: Svchip_ReflectionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ReflectionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_reflection(inputs)
	if (locale === "bn") return bn_svchip_reflection(inputs)
	if (locale === "de") return de_svchip_reflection(inputs)
	if (locale === "es") return es_svchip_reflection(inputs)
	if (locale === "fr") return fr_svchip_reflection(inputs)
	if (locale === "pt") return pt_svchip_reflection(inputs)
	if (locale === "zh") return zh_svchip_reflection(inputs)
	if (locale === "tr") return tr_svchip_reflection(inputs)
	if (locale === "ru") return ru_svchip_reflection(inputs)
	if (locale === "pl") return pl_svchip_reflection(inputs)
	return en_svchip_reflection(inputs)
});